<!-- template for the <modal></modal> component -->
<template lang="pug" id="modal-template">
  transition(name="modal")
    .c-modal-mask#overlay
      .c-modal-wrapper
        .c-modal-container
          .c-modal-header
            slot(name="header")
              .c-modal-header__left
                div(v-if="left" @click="close()")
                  i.material-icons {{ left }}
              .c-modal-header__title
                span(v-html="title")
              .c-modal-header__right
                button.c-button.c-button--tiny.c-button--secondary(v-if="right" type="button" @click="$emit('save')" v-bind:disabled="disabled") {{ right }}

          .c-modal-body
            slot(name="body")

          .c-modal-footer
            slot(name="footer")
              button.c-modal-default-button(@click="close()") OK
</template>

<script lang="babel">
  import ListenerMixin from '../mixins/ListenerMixin'
  
  export default {
    mixins: [ ListenerMixin ],
    props: {
      title: {
        type: String,
        default: null,
      },
      right: {
        type: String,
        default: '保存',
      },
      left: {
        type: String,
        default: 'close',
      },
      disabled: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
      }
    },
    created () {
      this.$_listenerMixin_listen(window, 'click', function(e){
        // if (!this.$el.contains(e.target)){
        //   this.$emit('close');
        // }
        if ( e.target.id == 'overlay' ) {
          this.close()
        }
      }.bind(this));
    },
    methods: {
      close () {
        this.$emit('close')
      }
    },
  }
</script>

<style lang="sass">

</style>